const TYPE = 'etuw-game-executor-v1'
const later = window.setTimeout.bind(window), clear = window.clearTimeout.bind(window)
const GAME_ORIGINS = process.env.VUE_APP_TOOL_BRIDGE_DEMO === '1'
  ? ['http://127.0.0.1:8087']
  : ['https://game.etuw.cn', 'https://app.xxh5.z7xz.com']

// The receiver announces itself from the actual game document, including through wrappers.
export function createExecutionBridge({ getFrame, changed = () => {}, host = window,
  origins = GAME_ORIGINS }) {
  let port = null, source = null, docId = '', ready = null, counter = 0, pending = new Map(), disposed = false
  function descendant(win) {
    const root = getFrame() && getFrame().contentWindow
    if (!root || !win) return false
    try { for (let n = 0; n < 8; n++) { if (win === root) return true; if (win === win.parent) break; win = win.parent } } catch (_) {}
    return false
  }
  function disconnect() {
    if (port) { try { port.postMessage({ type: TYPE, command: 'disconnect' }) } catch (_) {}; port.close() }
    port = null; source = null; ready = null; docId = ''
    pending.forEach(p => { clear(p.timer); p.reject(new Error('游戏连接已断开')) }); pending.clear(); changed()
  }
  function announced(event) {
    const data = event.data
    if (disposed || !origins.includes(event.origin) || !descendant(event.source) || !data || data.type !== TYPE || data.command !== 'ready' || typeof data.document !== 'string' || data.document.length > 80) return
    if (typeof host.MessageChannel !== 'function') return
    if (source === event.source && docId === data.document && port) return
    disconnect(); source = event.source; docId = data.document
    const channel = new host.MessageChannel(), connectedPort = port = channel.port1
    port.onmessage = e => {
      const response = e.data || {}
      if (port !== connectedPort || response.type !== TYPE || response.document !== docId) return
      if (response.command === 'connected') { ready = { speedReady: response.speedReady === true, clickReady: response.clickReady === true, rate: Number.isFinite(response.rate) ? response.rate : 1 }; changed(); return }
      if (response.command === 'closed') { disconnect(); return }
      const waiter = pending.get(response.id)
      if (!waiter) return
      clear(waiter.timer); pending.delete(response.id)
      if (response.ok) {
        if (waiter.command === 'speed' && response.result && Number.isFinite(response.result.rate)) { ready.rate = response.result.rate; changed() }
        waiter.resolve(response.result)
      }
      else waiter.reject(new Error(typeof response.error === 'string' ? response.error.slice(0,160) : '游戏执行失败'))
    }
    port.start()
    event.source.postMessage({ type: TYPE, command: 'connect', document: docId }, event.origin, [channel.port2])
  }
  host.addEventListener('message', announced)
  return {
    status() { return ready && descendant(source) ? { ...ready, document: docId } : null },
    request(command, value) {
      if (!ready || !descendant(source) || !['speed','click','pick'].includes(command)) return Promise.reject(new Error('游戏执行模块尚未连接'))
      return new Promise((resolve,reject) => {
        const id = ++counter
        const timer = later(() => { pending.delete(id); reject(new Error('游戏未确认操作，请重新连接后再试')); disconnect() }, command === 'pick' ? 60000 : 2500)
        pending.set(id,{resolve,reject,timer,command})
        port.postMessage({ type: TYPE, id, command, value, document: docId })
      })
    },
    disconnect,
    destroy() { disposed = true; host.removeEventListener('message',announced); disconnect() },
  }
}
